/**
 * バーの色
 */
export default class BarColor {
  public constructor(public readonly code: string) {}

  public static fromTask(task: Task): BarColor {
    if (task.subTasks.length > 0) {
      if (task.subTasks.some(t => t.behind)) {
        return BarColor.red();
      }
      if (task.subTasks.some(t => !(t.users && t.users.length))) {
        return BarColor.gray();
      }
      return BarColor.orange();
    }
    return BarColor.yellow();
  }

  public static yellow(): BarColor {
    return new BarColor("rgba(248, 231, 28, 0.6)");
  }

  public static orange(): BarColor {
    return new BarColor("rgba(255, 145, 49, 0.5)");
  }

  public static red(): BarColor {
    return new BarColor("rgba(239, 83, 80, 0.5)");
  }

  public static gray(): BarColor {
    return new BarColor("rgb(204, 204, 204, 1)");
  }
}

interface Task {
  subTasks: SubTask[];
}

interface SubTask {
  behind: boolean;
  users?: { id: string | number; name: string }[];
}
